export const pluginId = 'i18n';
